/**
 * Application-wide constants
 * Contains magic numbers, default values, and configuration constants
 */

/**
 * Current NFL season year
 * Update this value when a new season starts
 */
export const CURRENT_YEAR = 2026;

/**
 * Default week number (1 = first week of season)
 */
export const DEFAULT_WEEK = 1;

/**
 * Year range for available data
 * First year of available data to current year
 */
export const FIRST_YEAR = 2010;
export const LAST_YEAR = CURRENT_YEAR;

/**
 * Generates an array of years from FIRST_YEAR to LAST_YEAR (inclusive)
 * @returns Array of years in descending order
 */
export const getAvailableYears = (): number[] => {
  const years: number[] = [];
  for (let year = LAST_YEAR; year >= FIRST_YEAR; year--) {
    years.push(year);
  }
  return years;
};

/**
 * Default view settings
 */
export const DEFAULT_YEAR_AGGREGATE = true;
export const DEFAULT_CONFERENCE_VIEW = false;




